import { combineReducers } from "@reduxjs/toolkit";
import fcpTasksReducer from "./FCPTasks/fcpTasksSlice";

const publicReducer = combineReducers({ fcpTasks: fcpTasksReducer });

export default publicReducer;
